// React
import { useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export function useDataCode() {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<string>("")

  const refetch = (params: {
    returncode: string
    date_request: string
    jenis: number
  }): void => {
    api.get(
      "/received/generate_return_refund_code",
      { params }
    ).then((res: SuccessFetch<{
      payload: { next_code: string }
    }>) => {
      setData(res.data.payload.next_code)
    }).catch(() => {
      setData("")
    })
  }

  return { data, refetch }
}